import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "~/lib/utils";

const spinnerVariants = cva("relative inline-block shrink-0 animate-spin rounded-full border-neutral-300", {
  variants: {
    size: {
      sm: "size-4 border-[3px]",
      md: "size-6 border-4",
      lg: "size-10 border-[6px]",
    },
    color: {
      brand: "border-t-bouncie-500 border-r-bouncie-500 border-l-bouncie-500",
      subtle: "border-t-neutral-500 border-r-neutral-500 border-l-neutral-500",
      white: "border-t-white border-r-white border-l-white",
    },
  },
  defaultVariants: {
    size: "sm",
    color: "brand",
  },
});

export interface SpinnerProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "color">,
    VariantProps<typeof spinnerVariants> {
  label?: string;
}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size, color, label = "Loading…", ...props }, ref) => (
    <div ref={ref} role="status" className={cn(spinnerVariants({ size, color, className }))} {...props}>
      <span className="sr-only">{label}</span>
    </div>
  ),
);
Spinner.displayName = "Spinner";

export { Spinner, spinnerVariants };
